module.exports = __webpack_public_path__ + "static/media/logo-light.3e02b27f.svg";